import Auth from '../modules/Authentication'
import {apiUrl} from '../variables/index'
import {handleErrors, handleResponse} from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Sessions {
  constructor() {
    this.auth = new Auth()
  }

  list = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}sessions/`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  }
}
